export enum EAsyncStatus {
    IDLE = 'idle',
    PENDING = 'pending',
    RESOLVED = 'resolved',
    REJECTED = 'rejected'
  }
  